<div class="cloneprt">
    <h2 mat-dialog-title>Clone Plan</h2>
    <div>
        <form [formGroup]="clonePlanForm">
            <div class="radio_wrap">
                <mat-radio-group aria-label="Select an option" formControlName="cloneType">
                    <mat-radio-button value="both">All</mat-radio-button>
                    <mat-radio-button value="propertyType">Property Type</mat-radio-button>
                    <mat-radio-button value="propertySize">Property Size</mat-radio-button>
                </mat-radio-group>
            </div>
            <div class="propertyField">
                <mat-form-field fxFlex="auto" appearance="outline" *ngIf="clonePlanForm.value.cloneType === 'both' || clonePlanForm.value.cloneType === 'propertyType'">
                    <mat-label>Property Type</mat-label>
                    <mat-select formControlName="planPropertyTypeId">
                      <mat-option *ngFor="let item of data?.propertyTypes" [value]="item?.planPropertyTypeId">{{item?.title}} {{item?.lastName}}</mat-option>
                    </mat-select>
                    <mat-error *ngIf="clonePlanForm.controls['planPropertyTypeId'].touched && clonePlanForm.controls['planPropertyTypeId'].hasError('required')">
                      This is a required field.</mat-error>
                </mat-form-field>
                <mat-form-field fxFlex="auto" appearance="outline" *ngIf="clonePlanForm.value.cloneType === 'both' || clonePlanForm.value.cloneType === 'propertySize'">
                    <mat-label>Property Size</mat-label>
                    <mat-select formControlName="planPropertySizeId">
                      <mat-option *ngFor="let item of data?.propertySizes" [value]="item?.planPropertySizeId">{{item?.title}} {{item?.lastName}}</mat-option>
                    </mat-select>
                    <mat-error *ngIf="clonePlanForm.controls['planPropertySizeId'].touched && clonePlanForm.controls['planPropertySizeId'].hasError('required')">
                      This is a required field.</mat-error>
                </mat-form-field>
            </div>
        </form>


        <div class="actions" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="8px">
        
            <button mat-button class="sub-button" (click)="clonePlan()"><span>Clone Plan</span></button>
            <button mat-button mat-dialog-close class="can-button" (click)="onNoClick()"><span>Close</span></button>
        </div>
    </div>
</div>

